import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '../..';
import ConfettiWrapper from '../ConfettiWrapper';
const Video = _ref => {
  let {
    description,
    handleOnClick,
    primaryBtnTitle,
    isFreeVideo,
    subTitle,
    thumbnailUrl,
    title
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, thumbnailUrl ? isFreeVideo ? /*#__PURE__*/React.createElement(ConfettiWrapper, {
    thumbnailUrl: thumbnailUrl
  }) : /*#__PURE__*/React.createElement("img", {
    className: "thumbnail-img",
    src: thumbnailUrl,
    alt: "video thumbnail"
  }) : /*#__PURE__*/React.createElement("div", {
    className: "thumbnail-img-placeholder"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "play-circle-filled"
  })), /*#__PURE__*/React.createElement("div", {
    className: "info-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title-block"
  }, !isFreeVideo && /*#__PURE__*/React.createElement(Icon, {
    name: "play-circle-filled"
  }), /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, title), subTitle && /*#__PURE__*/React.createElement("span", {
    className: "subtitle"
  }, subTitle)), /*#__PURE__*/React.createElement("p", {
    className: "desc"
  }, description)), handleOnClick && /*#__PURE__*/React.createElement(Button, {
    color: "white",
    iconName: "play-circle-filled",
    className: "video-btn",
    title: primaryBtnTitle,
    onClick: handleOnClick
  }));
};
Video.propTypes = {
  description: PropTypes.string,
  handleOnClick: PropTypes.func,
  primaryBtnTitle: PropTypes.string,
  isFreeVideo: PropTypes.bool,
  shareVideo: PropTypes.func,
  subTitle: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  title: PropTypes.string
};
export default /*#__PURE__*/memo(Video);